import Drupal from 'drupal';
import once from 'once';

const MENU_SELECTOR = '.c-menu--main';
const BUTTON_SELECTOR = '.js-menu-main-toggle';
const SUBNAV_SELECTOR = '.c-menu__subnav';

let menuIdSequence = 0;

const hasUswdsAccordion = () =>
  typeof window !== 'undefined' && window.uswdsPresent === true;

const collapseButton = button => {
  const controlledId = button.getAttribute('aria-controls');
  const target = controlledId
    ? document.getElementById(controlledId)
    : button.nextElementSibling;
  button.setAttribute('aria-expanded', 'false');
  if (target) {
    target.hidden = true;
  }
};

const expandButton = button => {
  const controlledId = button.getAttribute('aria-controls');
  const target = controlledId
    ? document.getElementById(controlledId)
    : button.nextElementSibling;
  button.setAttribute('aria-expanded', 'true');
  if (target) {
    target.hidden = false;
  }
};

const prepareButton = (menu, button, index) => {
  const subnav =
    button.nextElementSibling &&
    button.nextElementSibling.matches(SUBNAV_SELECTOR)
      ? button.nextElementSibling
      : null;
  if (!subnav) {
    return null;
  }

  if (!subnav.id) {
    if (!menu.id) {
      menuIdSequence += 1;
      menu.id = `hhsds-menu-main-${menuIdSequence}`;
    }
    const menuId = menu.id;
    subnav.id = `${menuId}-section-${index}`;
  }

  button.setAttribute('aria-controls', subnav.id);

  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  subnav.hidden = !isExpanded;

  return subnav;
};

const initMenu = menu => {
  const buttons = Array.from(menu.querySelectorAll(BUTTON_SELECTOR));
  const useUswdsAccordion = hasUswdsAccordion();

  const collapseAll = () => {
    buttons.forEach(collapseButton);
  };

  const getExpandedButton = () =>
    buttons.find(button => button.getAttribute('aria-expanded') === 'true');

  buttons.forEach((button, index) => {
    const subnav = prepareButton(menu, button, index);
    if (!subnav) {
      return;
    }

    if (useUswdsAccordion) {
      return;
    }

    button.addEventListener('click', event => {
      event.preventDefault();
      const currentlyExpanded = button.getAttribute('aria-expanded') === 'true';

      buttons.forEach(otherButton => {
        if (otherButton !== button) {
          collapseButton(otherButton);
        }
      });

      if (currentlyExpanded) {
        collapseButton(button);
      } else {
        expandButton(button);
      }
    });
  });

  /**
   * Close menu when clicking outside.
   */
  document.addEventListener(
    'click',
    event => {
      if (menu.contains(event.target)) {
        return;
      }

      collapseAll();
    },
    { capture: true }
  );

  /**
   * Close menu when pressing Escape.
   */
  document.addEventListener(
    'keydown',
    event => {
      if (event.key !== 'Escape') {
        return;
      }

      const expandedButton = getExpandedButton();

      if (!expandedButton) {
        return;
      }

      const focusIsInsideMenu = menu.contains(document.activeElement);

      collapseAll();

      /**
       * If the user was focused inside the menu/flyout,
       * return focus to the button that opened it.
       */
      if (focusIsInsideMenu) {
        expandedButton.focus();
      }
    },
    { capture: true }
  );

  /**
   * Close menu when keyboard focus leaves the menu.
   * This handles Tab / Shift+Tab naturally.
   */
  document.addEventListener(
    'focusin',
    event => {
      if (menu.contains(event.target)) {
        return;
      }

      collapseAll();
    },
    { capture: true }
  );
};

Drupal.behaviors.menuMain = {
  attach(context) {
    once('hhsds-menu-main', MENU_SELECTOR, context).forEach(initMenu);
  },
};
